import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const titles = {
  '/': 'Fu-Tek Automation',
  '/about': 'About Us | Fu-Tek Automation',
  '/products': 'Products | Fu-Tek Automation',
  '/ContactUs': 'Contact Us | Fu-Tek Automation',
  '/careers': 'Careers | Fu-Tek Automation',

  // Solutions
  '/solutions/semiconductor': 'Semiconductor | Fu-Tek Automation',
  '/solutions/battery': 'Battery | Fu-Tek Automation',
  '/solutions/automobiles': 'Automotive Industry | Fu-Tek Automation',
  '/solutions/foodanddrink': 'Food & Drink Industry | Fu-Tek Automation',
  '/solutions/port': 'Port Industry | Fu-Tek Automation',
  '/solutions/print': 'Print Industry | Fu-Tek Automation',
  '/solutions/packaging': 'Packaging Industry | Fu-Tek Automation',
  '/solutions/RubberAndPlastic': 'Rubber & Plastic Industry | Fu-Tek Automation',
  '/solutions/EnergyIndustry': 'Energy Industry | Fu-Tek Automation',
  '/solutions/IndustrialRobots': 'Industrial Robots | Fu-Tek Automation',
  '/solutions/ElectronicsIndustry': 'Electronics Industry | Fu-Tek Automation',
  '/solutions/LogisticsIndustry': 'Logistics Industry | Fu-Tek Automation',
  '/solutions/MedicalTechnology': 'Medical Technology | Fu-Tek Automation',

  // Product Categories - Position Sensors
  '/products/InductiveSensor': 'Inductive Sensors | Fu-Tek Automation',
  '/products/PhotoelectricSensors': 'Photoelectric Sensors | Fu-Tek Automation',
  '/products/CapacitiveSensor': 'Capacitive Sensors | Fu-Tek Automation',
  '/products/MagneticSensor': 'Magnetic Sensors | Fu-Tek Automation',
  '/products/UltrasonicSensor': 'Ultrasonic Sensors | Fu-Tek Automation',
  '/products/ColorMarkDetection': 'Color Mark Detection | Fu-Tek Automation',

  // Product Categories - Process / Fluid Sensors
  '/products/PressureVacuumSensor': 'Pressure & Vacuum Sensors | Fu-Tek Automation',
  '/products/LevelSensor': 'Level Sensors | Fu-Tek Automation',
  '/products/FlowSensorsFlowMeters': 'Flow Sensors / Flow Meters | Fu-Tek Automation',
  '/products/TemperatureSensors': 'Temperature Sensors | Fu-Tek Automation',
  '/products/AnalyticalSensors': 'Analytical Sensors | Fu-Tek Automation',

  // Product Categories - Smart Tech
  '/products/VisionSensor': 'Vision Sensor | Fu-Tek Automation',
  '/products/CodeReader': 'Code Reader | Fu-Tek Automation',
  '/products/AreaObstacleAvoidanceSensor': 'Area/Security/Obstacle Avoidance Sensor | Fu-Tek Automation',

  // Other Pages
  '/solutions': 'Solutions | Fu-Tek Automation',
  '/ProcessDevice': 'Process Devices | Fu-Tek Automation',
  '/PositionSensor': 'Position Sensors | Fu-Tek Automation',
  '/ProcessFluidSensors': 'Process / Fluid Sensors | Fu-Tek Automation',
  '/AiImageRecognition': 'AI Image Recognition | Fu-Tek Automation',
  '/CodeReaderNew': 'Code Reader | Fu-Tek Automation',
  '/SafetySensor': 'Safety Sensor | Fu-Tek Automation',
  '/TestBox': 'Test Box | Fu-Tek Automation',
  '/ChemicalEngineering': 'Chemical Engineering | Fu-Tek Automation'
};

const RouteTitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = titles[location.pathname] || 'Fu-Tek Automation';
  }, [location.pathname]);

  return null;
};

export default RouteTitleManager;
